<div
  *ngIf="item"
  class="relative flex min-h-[84px] items-center justify-between gap-4 border border-t border-white bg-pl-gray-200"
  [class.border-b]="isLast"
  [class.pointer-events-none]="isDisabled"
>
  <label
    class="pl-radio-item-container block w-full cursor-pointer select-none p-5 pr-20 text-lg text-pl-gray-450"
    [ngClass]="{
      disabled: isDisabled,
      'opacity-30': isDisabled && item.value !== radioValue
    }"
  >
    <div class="flex grow flex-col gap-2">
      <p class="font-sans text-inherit">{{ item.label }}</p>
      <p *ngIf="item.sub_label" class="font-sans font-bold text-inherit">- {{ item.sub_label }}</p>
      <p
        *ngIf="item.feedback && item.value === radioValue"
        class="border-l border-pl-green-500 pl-2 font-sans text-pl-green-500"
      >
        {{ item.feedback }}
      </p>
    </div>
    <input
      type="radio"
      [name]="name"
      class="absolute h-0 w-0 cursor-pointer opacity-0"
      [value]="item.value"
      [(ngModel)]="radioValue"
      (ngModelChange)="onRadioChange()"
    />
    <span
      #customRadio
      class="checkmark absolute right-5 top-5 mx-0 h-11 w-11 rounded-full border-2 border-pl-gray-500 bg-white"
      tabindex="2"
      [ngClass]="{ 'focus:border-pl-blue-500': !isDisabled }"
      [class.border-pl-green-500]="item.value === radioValue && !isDisabled"
      [class.border-pl-gray-700]="item.value === radioValue && isDisabled"
      (keydown)="onKeyDownOnCheckmark($event, item)"
    >
      <pl-icon
        class="tick-icon block scale-0 transition-all"
        [class.scale-100]="item.value === radioValue"
        [class.text-pl-green-500]="item.value === radioValue && !isDisabled"
        [class.text-pl-gray-700]="item.value === radioValue && isDisabled"
        [name]="PlIcon.tick"
      ></pl-icon>
    </span>
  </label>
</div>
